import styled from 'styled-components';

export const GaugeChartWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
